import { $t } from '@/i18n';
import XyPageletContainer from './xy-pagelet-container';
import xyPageletSchema from './xy-pagelet-schema';
import PageletAttr from './pagelet-attr';
import { EVENTS } from '@composables/usePageletEvent';

export default {
  component: XyPageletContainer,
  componentForDesign: XyPageletContainer,
  category: $t('k_b38ad245'),
  id: 'xy-pagelet-container',
  events: EVENTS,
  slots: [
    { id: 'default', selector: '.xy-pagelet-container' },
  ],
  display: 'block',
  visible: false,
  name: $t('k_2f628aaf'),
  readme: '',
  propPanel: {
    PageletAttr: {
      component: PageletAttr,
      hideLabel: true,
    },
  },
  propsSchema: xyPageletSchema,
};

